import React from 'react'
import { useState, useEffect } from 'react'
import './headerpresentation.css'
import { useLanguage } from '../../context/LanguageContext'


const HeaderPresentation = () => {
  const { t, lang } = useLanguage()
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const period = 2000;

  // Reset animation when language changes
  useEffect(() => {
    setLoopNum(0);
    setIsDeleting(false);
    setText('');
    setDelta(300 - Math.random() * 100);
  }, [lang])

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text])

  const tick = () => {
    const toRotate = t.header.roles;
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(500);
    }
  }


  return (
    <section className='container headerpresentation__blck'>
      <div className='headerpresentation__entete'>
        <h3 className='headerpresentation__entete--title'>{t.header.welcome}</h3>
        <h1 className='headerpresentation__entete--pres'>{`${t.header.greeting} `}
          <span className="txt-rotate" dataPeriod="1000">
            <span className='wrap'>{text}</span>
          </span> 
        </h1>
        <p className='headerpresentation__bio'>{t.header.bio}</p>
        <div className='headerpresentation__stats'>
          {t.header.stats.map((s, i) => (
            <div key={i} className='headerpresentation__stat'>
              <span className='stat-value'>{s.value}</span>
              <span className='stat-label'>{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default HeaderPresentation